<template>
    <div v-if="template.template_context === 'custom_automated_message'">
        <h2 class="text-h6 my-4">
            <strong>Custom Automated Message Instructions</strong>
        </h2>

        <m-display-text
            label="URL"
            class="mt-4"
            :value="custom_webhook_url"
        />

        JSON Body Shape
        <m-code-block :click_anywhere_to_copy="false">
            {<br/>
                "first_name" : "John",<br/>
                "last_name" : "Doe",<br/>
                "to" : "237-111-2345",<br/>
                "custom-semantic-meaning": "1234"<br/>
                // Optional: any custom fields you would like to use in your message<br/>
            }<br/>
        </m-code-block>

        <p>
            For details on how to trigger a custom automated message <a href="https://redchirp.com/how-to-setup-custom-automated-messages/" target="_blank">click here</a>.
        </p>
    </div>
</template>

<script>
export default {
    props: {
        template: {
            type: Object,
            required: true
        },
        custom_webhook_url: {
            type: String,
            required: true
        }
    }
}
</script>
